export enum AgoraUserEvents {
    UserPublished= 'user-published',
    UserUnpublished = 'user-unpublished',
    UserJoined = 'user-joined',
    UserLeft = 'user-left'
}